<div
  class="h-min-[180px] relative w-[375px] rounded-[20px] border pb-[22px] pt-[13px] shadow-[0px_5px_20px_0px_rgba(0,0,0,0.20)]">
  <!--  card body-->
  <div class="pl-[24px] pr-[12px]">
    <div class="flex items-start gap-x-[11.36px]">
      <button (click)="navigateToProductDetails()" class="flex h-[112px] w-[81.6px]">
        <ln-ln-image-frame
          [src]="product.producto.activosDigitales[0].urlImg"
          alt="Imagen del producto"
          class="h-[112px] w-[81.6px] rounded-lg"></ln-ln-image-frame>
      </button>
      <div class="w-full">
        <button (click)="navigateToProductDetails()" class="flex flex-row items-start justify-start">
          <div class="w-full text-start line-clamp-2 overflow-hidden text-ellipsis break-words text-base font-semibold text-cafe">{{ product.producto.productoPrincipal.nombre }}</div>
        </button>

        @if (singlePiece) {
          <div class="justify-center text-naranja text-sm font-normal font-['Roboto'] leading-none">{{'messages.availabilityWillBeEvaluated' | transloco}}</div>
        }

        <div class="flex flex-col">
          <!--        precio y incrementar decrementar  component-->
          <section>
            <div [ngClass]="[singlePiece ? 'justify-end pr-[58px] mt-[8px]': 'items-center gap-x-[12.65px] mt-[16px]', 'flex']">
              @if (!singlePiece) {
                <div class="gap-x-[4px]">
                  @if(product.producto.precioOferta | number:'1.0-0') {
                    <div class="text-end text-base font-bold text-cafe">
                      $ {{ product.producto.precioOferta | number:'1.0-0'}} <span class="text-xs font-bold">USD</span>
                    </div>
                    <div class="text-sm font-normal text-verde">
                      <span class="line-through"> $ {{ product.producto.precio | number:'1.0-0'}}</span> <span class="text-xs"> USD</span>
                    </div>
                  } @else {
                    <div class="text-end text-base font-bold text-cafe">
                      $ {{ product.producto.precio | number:'1.0-0'}} <span class="text-xs font-bold">USD</span>
                    </div>
                  }

                </div>
              }
              <div>
                <ln-product-item-card-quantity-selector
                  [quantity]="product.cantidad"
                  [productID]="product.id"
                  [showButonSpinner]="showButonSpinner"></ln-product-item-card-quantity-selector>
              </div>
            </div>
          </section>

          <!--eliminar y guardar para mas tarde-->
          <section>
            <div class="mt-[12px] flex gap-x-[5px]">
              <button (click)="deleteItem()" class="text-sm font-normal text-verde underline">
                <div class="flex hover:font-semibold">
                  <span><ln-trash-svg-icon class="h-[18px] w-[18px]"></ln-trash-svg-icon></span>{{'buttons.delete' | transloco}}
                </div>
              </button>

<!--              <button class="text-sm font-normal text-verde underline">-->
<!--                <div class="flex hover:font-semibold">-->
<!--                  <span><ln-book-mark-svg-icon class="h-[18px] w-[18px]"></ln-book-mark-svg-icon></span>{{'buttons.saveForLater' | transloco}}-->
<!--                </div>-->
<!--              </button>-->
              <div></div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <div class="mt-[18px] justify-start text-xs font-normal text-cafe">
      {{'labels.exchangeAndReturnPolicyOf' | transloco}}<span class="font-medium"> {{'labels.lunaNuevaHome' | transloco}}</span>
    </div>
  </div>
  @if (showButonSpinner()) {
    <div class="absolute inset-0 z-10 flex items-center justify-center rounded-[20px] bg-white/60">
      <div
        class="h-[80px] w-[80px] animate-spin rounded-full border-4 border-verde border-t-transparent"
        role="status"></div>
    </div>
  }
</div>
